import {
  alpha,
  createSvgIcon,
  Paper,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { ReactComponent as IconFlow } from "../../../assets/icons/IconEasyFlow.svg";
import { ReactComponent as IconReport } from "../../../assets/icons/IconEasyReport.svg";
import { ReactComponent as IconMaps } from "../../../assets/icons/IconEasyMaps.svg";
import { ReactComponent as IconLog } from "../../../assets/icons/IconEasyLog.svg";
import { ReactComponent as IconBi } from "../../../assets/icons/IconEasyBI.svg";
import { ReactComponent as IconMon } from "../../../assets/icons/IconEasyMon.svg";
import { Switch, Box, Tooltip } from "@mui/material";

const EasyFlowIcon = createSvgIcon(<IconFlow />);
const EasyReportIcon = createSvgIcon(<IconReport />);
const EasyMapsIcon = createSvgIcon(<IconMaps />);
const EasyLogIcon = createSvgIcon(<IconLog />);
const EasyBiIcon = createSvgIcon(<IconBi />);
const EasyMonIcon = createSvgIcon(<IconMon />);
const modules = [
  { name: "EasyMon", icon: EasyMonIcon, color: "#E84B21" },
  {
    name: "EasyFlow",
    icon: EasyFlowIcon,
    color: "#2DC989",
  },
  {
    name: "EasyMaps",
    icon: EasyMapsIcon,
    color: "#E94159",
  },
  {
    name: "EasyReport",
    icon: EasyReportIcon,
    color: "#F48206",
  },
  {
    name: "EasyLog",
    icon: EasyLogIcon,
    color: "#E93136",
  },
  {
    name: "EasyBI",
    icon: EasyBiIcon,
    color: "#039fdd",
  },
];

export default function ModulosConfig() {
  const { setSubTitle, setChanges, changes, settings } = useOutletContext();
  const theme = useTheme();

  const [module, setModule] = useState({});

  const produto = "modulos";

  useEffect(() => {
    setSubTitle("Módulos");
  }, []);

  useEffect(() => {
    if (!settings) return;

    let settingsData = settings.find((item) => item.produto === produto);

    if (settingsData) {
      setModule(settingsData?.configuracoes || {});
    }
  }, [settings]);

  const updateModule = (modName, value) => {
    setModule((prev) => ({
      ...prev,
      [modName]: value,
    }));
    setChanges((data) => ({
      ...data,
      product: produto,
      settings: {
        ...module,
        [modName]: value,
      },
    }));
  };

  const styles = {
    textFieldSelect: {
      "& .MuiInputBase-input": { fontSize: "0.875rem" },
      "& .MuiOutlinedInput-root": {
        background: alpha(theme.palette.background.paper, 0.7),
        ":hover": { background: alpha(theme.palette.background.paper, 0.9) },
      },
      minWidth: "min-content",
    },
    labels: { fontSize: "14px", fontWeight: 500, color: "text.primary" },
    text: { fontSize: "0.95rem", fontWeight: 500 },
    textFine: {
      fontSize: "0.86rem",
      mt: "-2px",
      color: theme.palette.text.shadow,
    },
    boxOP: {
      backgroundColor: theme.palette.background.paper,
      border: "1px solid" + theme.palette.background.paperOutlined,
      p: 2,
      borderRadius: "5px",
    },
    textField: {
      fontSize: "14px",
      width: "100%",
      "& .MuiInputBase-input": {
        fontSize: "0.9rem",
        height: "20px!important",
      },
      '& input[type="number"]::-webkit-outer-spin-button': { display: "none" },
      '& input[type="number"]::-webkit-inner-spin-button': { display: "none" },
      '& input[type="number"]': { MozAppearance: "textfield" },
      "& .MuiOutlinedInput-root": {
        boxShadow: "none",
        "&.Mui-focused": { boxShadow: "none", border: "none" },
      },
    },
    textAdorment: {
      ml: "-5px",
      fontSize: "0.875em",
      fontWeight: 800,
      color: theme.palette.text.disabled,
      width: "max-content",
    },
    containerPredefinicoes: {
      ml: "0px",
      mr: "0px",
      p: "10px 15px",
      mt: 2,
      width: "100%",
      borderRadius: "5px",
      backgroundColor: theme.palette.background.textField,
    },
    moduleCard: {
      p: 1,
      borderRadius: 3,
      boxShadow: 2,
      display: "flex",
      alignItems: "center",
      gap: 3,
      background: theme.palette.background.paper,
      border: `1.5px solid ${theme.palette.background.paperOutlined}`,
      transition: "box-shadow 0.2s",
      "&:hover": {
        boxShadow: 6,
        borderColor: theme.palette.primary.light,
      },
    },
    iconBox: (color) => ({
      background: alpha(color, 0.12),
      borderRadius: "50%",
      p: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: 1,
      minWidth: 56,
      minHeight: 56,
    }),
    moduleName: {
      fontWeight: 600,
      fontSize: "1.1rem",
      color: "text.primary",
    },
    moduleDesc: {
      fontSize: "0.93rem",
      color: "text.secondary",
      mt: 0.5,
    },
  };

  return (
    <Stack gap={3} mb={8}>
      <Paper sx={styles.boxOP}>
        <Stack direction="column">
          <Typography sx={styles.text}>Controle de Módulos</Typography>
          <Typography sx={styles.textFine}>
            Ative ou desative os módulos do Sistema MW.
          </Typography>
        </Stack>
      </Paper>

      <Stack gap={2}>
        {modules.map((mod) => (
          <Box key={mod.name} sx={styles.moduleCard}>
            <Box sx={styles.iconBox(mod.color)}>
              <mod.icon
                sx={{
                  fontSize: 32,
                  color: mod.color,
                }}
              />
            </Box>
            <Box flex={1}>
              <Typography sx={styles.moduleName}>{mod.name}</Typography>
            </Box>
            <Tooltip title={`Ativar/desativar ${mod.name}`}>
              <Switch
                checked={module[mod.name] ?? true}
                color="primary"
                onChange={(e) => updateModule(mod.name, e.target.checked)}
              />
            </Tooltip>
          </Box>
        ))}
      </Stack>
    </Stack>
  );
}
